import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { getListNavigationState } from "../../utils/listNavigation";
import { ActionIcon, Menu, rem } from "@mantine/core";
import { IconDotsVertical } from "@tabler/icons-react";

const Actions = ({ rowData, actions, handler }) => {
  const [opened, setOpened] = useState(false);
  const location = useLocation();
  const listState = getListNavigationState(location);

  const menuStyles = {
    dropdown: {
      minWidth: rem(168),
      padding: rem(4),
      borderRadius: rem(8),
      boxShadow: "0px 2px 48px 0px rgba(75, 75, 75, 0.16)",
    },
    item: {
      fontSize: rem(14),
      fontWeight: 500,
      color: "var(--mantine-color-dark-7)",
      textDecoration: "none",
      width: "100%",
    },
  };

  const actionItems = actions.map((item, index) => (
    <Menu.Item
      key={index}
      component={Link}
      to={item.to(rowData)}
      state={listState}
    >
      {typeof item.label === "function" ? item.label(rowData) : item.label}
    </Menu.Item>
  ));

  const handlerItems = handler.map((item, index) => (
    <Menu.Item key={index} onClick={() => item.handler(rowData)}>
      {typeof item.label === "function" ? item.label(rowData) : item.label}
    </Menu.Item>
  ));

  return (
    <Menu
      onOpen={() => setOpened(true)}
      onClose={() => setOpened(false)}
      radius="md"
      position="bottom-end"
      transitionProps={{ transition: "pop" }}
      withinPortal
      styles={menuStyles}
    >
      <Menu.Target>
        <ActionIcon
          variant="subtle"
          color="gray"
          size={28}
          radius="xl"
          aria-label="Open row actions"
          styles={{
            root: {
              backgroundColor: opened ? "#f3f8fe" : "transparent",
            },
          }}
        >
          <IconDotsVertical size={18} color="#8EA2B5" stroke={2.5} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        {actionItems}
        {handlerItems}
      </Menu.Dropdown>
    </Menu>
  );
};

export default Actions;